import React from "react";
import { Button, Table } from "reactstrap";
import { IMessenger } from "src/app/contact/~store/models/Messenger";
import { IContactCommunicationListProps } from "./~types/ContactCommunicationListProps";

import "./ContactCommunicationList.css"
import { t } from "i18next";
import ContactCommunicationItem from "./contact-communication-item/ContactCommunicationItem";
import { useState } from "react";
import { initNewMessenger } from "src/app/contact/~store/state/InitContactState";

const ContactCommunicationList = (props: IContactCommunicationListProps) => {

    const [creatingContactCommunication, setCreatingContactCommunication] = useState<IMessenger | null>(null)

    const detachMessengerHandler = (msngr: IMessenger) => {
        if(msngr.messengerId === 0) {
            setCreatingContactCommunication(null);
        }
        else if(window.confirm(t('contact.deleteMessenger'))) {
            props.onDetach(msngr.messengerId);
        }
    } 
    
    const onCreateButtonClick = () => {
        setCreatingContactCommunication(initNewMessenger(props.selectedContact, props.allChannels[0]));
    }

    const onSaveMessenger = (messenger: IMessenger) => {
        setCreatingContactCommunication(null);

        props.onSaveMessenger(messenger);
    }

    const contactMessengers = creatingContactCommunication ? [creatingContactCommunication].concat(props.messengers) : props.messengers;

    const mapCommunicationsTable = () => {
        return (
            <Table className="contact-accounts__table">
                <thead>
                    <tr>
                        <td>
                            <Button disabled={props.selectedContact.contactId === 0}
                                onClick={onCreateButtonClick}
                                >{t('contact.createMessenger')}</Button>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <thead>
                    <tr>
                        <td className="contact-communication-column">{t('contact.channelName')}</td>
                        <td className="contact-communication-column">{t('contact.messengerToken')}</td>
                        <td className="contact-communication-column">{t('contact.messengerNickname')}</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {contactMessengers.map(msngr => {
                        return (
                            <ContactCommunicationItem key={msngr.messengerId}
                                onDetachMessenger={detachMessengerHandler}
                                onNewChatWithMessenger={props.newChatWithMessenger}
                                onSaveMessenger={onSaveMessenger}
                                messenger={msngr}
                                messengersCount={props.messengers.length}
                                allChannels={props.allChannels}
                            />
                        )
                    })}
                </tbody>

                
            </Table>
        )
    }

    return (
        <div>
            {mapCommunicationsTable()}
        </div>
    )
}

export default ContactCommunicationList;